// PRODUCTION — live-updates header status (updating spinner / "Updated HH:mm:ss").
import React, { memo } from 'react'
import tw from 'twin.macro'
import { CircularProgress, Typography } from '@mui/material'
import { DateTime } from 'luxon'

const StatusIndicatorComponent = ({
  refreshing,
  lastUpdatedAt,
}: {
  refreshing: boolean
  lastUpdatedAt: number | null
}) => {
  if (!refreshing && lastUpdatedAt === null) {
    return null
  }

  let label = 'Updating…'

  if (!refreshing && lastUpdatedAt !== null) {
    label = `Updated ${DateTime.fromMillis(lastUpdatedAt).toFormat('HH:mm:ss')}`
  }

  return (
    <div css={tw`flex items-center gap-1.5`}>
      {refreshing ? (
        <CircularProgress size={12} css={tw`text-primary-500`} />
      ) : (
        <span css={tw`h-2 w-2 rounded-full bg-success-500`} />
      )}
      <Typography variant="subtitle2" css={tw`text-shades-500`}>
        {label}
      </Typography>
    </div>
  )
}

export const StatusIndicator = memo(StatusIndicatorComponent)
